export default ($http, $parse) => ({
  restrict: "EA",
  scope: false,
  link($scope, $element, attrs) {
    const onFound = attrs.onFound && $parse(attrs.onFound);
    const onNotFound = attrs.onNotFound && $parse(attrs.onNotFound);
    const isReading = attrs.isReading && $parse(attrs.isReading);

    if (isReading) isReading.assign($scope, true);
	  $http.head(attrs.urlExists || attrs.src || attrs.href || attrs.url, { cache: false }).then(
      $response => {
        console.debug("urlExists.onFound", $response, $element);
        if (onFound) onFound($scope, { $response, $element });
        if (isReading) isReading.assign($scope, false);
      },
      $response => {
        console.debug("urlExists.onNotFound", $response, $element);
        if (onNotFound) onNotFound($scope, { $response, $element });
        if (isReading) isReading.assign($scope, false);
      }
    );
  } //link
});
